import { NavLink } from 'react-router-dom';

const menuItems = [
  { path: '/', icon: 'ri-dashboard-3-line', label: 'Genel Dashboard', exact: true },
  { path: '/applications', icon: 'ri-user-add-line', label: 'Uzman Başvuruları' },
  { path: '/scoring', icon: 'ri-star-line', label: 'Skorlama & Kalite' },
  { path: '/experts', icon: 'ri-team-line', label: 'Aktif Uzmanlar' },
  { path: '/leads', icon: 'ri-user-search-line', label: 'Müşteri Talepleri' },
  { path: '/matching', icon: 'ri-git-merge-line', label: 'Eşleşme & Randevu' },
  { path: '/revenue', icon: 'ri-money-dollar-circle-line', label: 'Gelir Analizi' },
  { path: '/performance', icon: 'ri-bar-chart-box-line', label: 'Performans & Algoritma' },
  { path: '/messages', icon: 'ri-message-3-line', label: 'Mesaj & Bildirim' },
  { path: '/leaderboard', icon: 'ri-trophy-line', label: 'Leaderboard & Büyüme' },
];

interface SidebarProps {
  collapsed: boolean;
  onToggle: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, onToggle }) => {
  return (
    <aside
      className={`fixed left-0 top-0 h-screen z-50 flex flex-col transition-all duration-300 ${
        collapsed ? 'w-16' : 'w-64'
      }`}
      style={{ background: 'linear-gradient(180deg, #0d0d14 0%, #0a0a0f 100%)', borderRight: '1px solid rgba(255,77,77,0.15)' }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3 px-4 py-5 border-b" style={{ borderColor: 'rgba(255,77,77,0.2)' }}>
        <img src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/bd4b0bdda5423219f47024c9b046e281.png" alt="BiMakas" className="w-8 h-8 rounded-lg object-contain flex-shrink-0" />
        {!collapsed && (
          <div>
            <div className="font-bold text-sm text-white leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>BiMakas</div>
            <div className="text-xs" style={{ color: '#ff8c42' }}>Admin Panel</div>
          </div>
        )}
        <button
          onClick={onToggle}
          className={`ml-auto text-gray-400 hover:text-white transition-colors cursor-pointer ${collapsed ? 'mx-auto' : ''}`}
        >
          <i className={`${collapsed ? 'ri-menu-unfold-line' : 'ri-menu-fold-line'} text-lg`}></i>
        </button>
      </div>

      {/* Nav Items */}
      <nav className="flex-1 py-4 overflow-y-auto overflow-x-hidden">
        <div className="space-y-1 px-2">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.exact}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 cursor-pointer group relative whitespace-nowrap ${
                  isActive
                    ? 'text-white'
                    : 'text-gray-400 hover:text-white hover:bg-white/5'
                }`
              }
              style={({ isActive }) =>
                isActive
                  ? {
                      background: 'linear-gradient(135deg, rgba(255,77,77,0.25) 0%, rgba(255,140,66,0.15) 100%)',
                      boxShadow: '0 0 12px rgba(255,77,77,0.2)',
                      borderLeft: '3px solid #ff4d4d',
                    }
                  : {}
              }
            >
              {({ isActive }) => (
                <>
                  <i
                    className={`${item.icon} text-lg flex-shrink-0`}
                    style={isActive ? { color: '#ff6b47' } : {}}
                  ></i>
                  {!collapsed && (
                    <span className="text-sm font-medium">{item.label}</span>
                  )}
                  {collapsed && (
                    <div
                      className="absolute left-full ml-2 px-2 py-1 rounded text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 whitespace-nowrap"
                      style={{ background: '#1a1a2e', border: '1px solid rgba(255,77,77,0.3)' }}
                    >
                      {item.label}
                    </div>
                  )}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>

      {/* Bottom User */}
      <div className="p-3 border-t" style={{ borderColor: 'rgba(255,77,77,0.15)' }}>
        <div
          className="flex items-center gap-2 p-2 rounded-lg"
          style={{ background: 'rgba(255,255,255,0.03)' }}
        >
          <div
            className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 text-white text-xs font-bold"
            style={{ background: 'linear-gradient(135deg, #ff4d4d, #ff8c42)' }}
          >
            A
          </div>
          {!collapsed && (
            <div className="min-w-0">
              <div className="text-xs font-medium text-white truncate">Admin</div>
              <div className="text-xs truncate" style={{ color: '#6b7280' }}>bimakas.com</div>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
